<template>
  <div class="material-specific-info-card">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
    />
    <component
      v-if="tabs[activeTab].id === 'details' && currentFamilyFieldsComponent !== null && materialSpecificFields"
      :is="currentFamilyFieldsComponent"
      :family-specific-fields="materialSpecificFields"
      :installationTypeOptions="installationTypeOptions"
      :lossValue="lossValue"
      :editingData="editingData"
      :style="{
        'overflow': 'auto',
        'height': tabContentHeight,
      }"
      @update-object="$emit('update-material', $event)"
      @update-loss-value="$emit('update-loss-value', $event)"
      @update-required-field="$emit('update-required-field', $event)"
      @updateFamilyIdSelect="$emit('update-family-id-select', $event)"
    />
    <div v-if="tabs[activeTab].id === 'accessories'" :key="updateAccessoriesKey" :style="{'height': tabContentHeight }">
      <Table
        :checkbox="false"
        :loading="loading"
        :headers="accessoriesOthersHeaders"
        :items="accessories"
        :add-row-button="editingData"
        :action-buttons="editingData"
        @input="updateAccessories($event)"
        @onScrollBottom="onScrollBottom"
        @onScrollTop="onScrollTop"
        @sortClick="onSortClick"
      />
    </div>
    <div v-if="tabs[activeTab].id === 'others'" :style="{'height': tabContentHeight }">
      <Table
        :checkbox="false"
        :loading="loading"
        :headers="accessoriesOthersHeaders"
        :items="others"
        :add-row-button="editingData"
        :action-buttons="editingData"
        @input="updateOthers($event)"
        @onScrollBottom="onScrollBottom"
        @onScrollTop="onScrollTop"
        @sortClick="onSortClick"
      />
    </div>
    <custom-fields-tab
      v-if="tabs[activeTab].id === 'custom_fields'" :style="{'overflow': 'auto', 'height': tabContentHeight }"
      :editing-data="editingData"
      :custom-fields-inputs="customFieldsInputs"
      :custom-fields-values="customFieldsValues"
      @update-object="$emit('update-custom-field', $event)"
      @update-required-field="$emit('update-required-field', $event)"
    />
    <div v-if="editingData" class="action-buttons">
      <custom-button
        :label="$t('Cancel')"
        :button-color="'#FFF'"
        :label-color="'#29BDF0'"
        :button-styling="actionButtonsStyling"
        @buttonClick="$emit('cancel-edit')"
      />
      <custom-button
        :label="$t(submitButtonLabel)"
        :button-color="'#29BDF0'"
        :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave"
        :disabled="!requiredFieldsFilled"
        @buttonClick="$emit('save-material')"
      />
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import CustomButton from '@/newComponents/_Atoms/CustomButton.vue';
import CableMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsCable";
import ClosureMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsClosure";
import SplitterMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsSplitter";
import PoleMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsPole";
import ChamberMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsChamber";
import CabinetMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsCabinet";
import TobyBoxMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsTobyBox";
import AccessoryOtherMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsAccessoryOther";
import PathwayMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsPathway";
import TechnicalSiteMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsTechnicalSite";
import MicroDuctMaterialFields from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsMicroDuct";
import MaterialFieldsRack from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsRack";
import MaterialFieldsDrawer from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsDrawer";
import MaterialFieldsCassette from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsCassette";
import MaterialFieldsFieldCable from "@/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsFieldCable";
import Table from '@/newComponents/_Molecules/Table';
import CustomFieldsTab from '@/newComponents/StockManagement/CustomFieldsTab';
import { mapActions } from "vuex";

export default {
  name: "MaterialSpecificInfo",

  components: {
    Tabs,
    CustomButton,
    Table,
    CustomFieldsTab,
  },

  props: {
    /**
     * Material family Id
     */
    materialFamilyID: {
      type: String,
      required: true
    },

    /**
     * Fields specific for the family of the chosen material
     */
    materialSpecificFields: {
      type: Object | Array,
      required: true
    },

    /**
     * Accessories of the chosen material
     */
    accessories: {
      type: Array,
      required: true
    },

    /**
     * Others of the chosen material
     */
    others: {
      type: Array,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },

    lossValue: {},

    /**
     * Possible types of installation for the chosen material
     */
    installationTypeOptions: {
      type: Array,
      required: true
    },

    requiredFieldsFilled: {
      type: Boolean,
      required: true,
    },

    submitButtonLabel: {
      type: String,
    },

    customFieldsInputs: {
      type: Array,
    },

    customFieldsValues: {
      type: Object,
    },
  },

  data() {
    return {
      activeTab: 0,
      updateAccessoriesKey: 1,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      loading: false,
      pageNumber: 1,
      lastPage: 2,
      accessoriesAndOthersOptions: null,
    }
  },

  computed: {
    /**
     * Determines with component should be shown with the specific material family fields
     * @returns {*}
     */
    currentFamilyFieldsComponent() {
      switch (this.materialFamilyID) {
        case "ca":
          return CableMaterialFields;
        case "cl":
          return ClosureMaterialFields;
        case "sp":
          return SplitterMaterialFields;
        case "pl":
          return PoleMaterialFields;
        case "ch":
          return ChamberMaterialFields;
        case "cb":
          return CabinetMaterialFields;
        case "tb":
          return TobyBoxMaterialFields;
        case "ac":
        case "ot":
          return AccessoryOtherMaterialFields;
        case "pt":
          return PathwayMaterialFields;
        case "ts":
          return TechnicalSiteMaterialFields;
        case "ud":
          return MicroDuctMaterialFields;
        case "rc":
          return MaterialFieldsRack;
        case "dw":
          return MaterialFieldsDrawer;
        case "ct":
          return MaterialFieldsCassette;
        case 'fc':
          return MaterialFieldsFieldCable;
        default:
          return null;
      }
    },

    accessoriesOthersHeaders() {
      return [
        {
          text: this.$i18n.tc("Reference", 1),
          varName: "sm_reference",
          editable: true,
          type: "select",
          options: this.accessoriesAndOthersOptions,
          required: true,
        },
        {
          text: this.$i18n.tc("Description", 1),
          varName: "sm_description",
          editable: false,
          type: "text",
        },
        {
          text: this.$i18n.t("Quantity"),
          varName: "sm_quantity",
          editable: true,
          type: "int_pos",
          required: true,
          min: 1,
          step: 1,
        },
      ];
    },

    relationFamilyIdSelect() {
      switch (this.materialFamilyID) {
        case "ca":
          return "ca";
        case "cl":
          return "cl";
        case "pl":
          return "pl";
        case "ch":
          return "ch";
        case "cb":
          return "pl";
        case "tb":
          return "tb";
        case "pt":
          return "pt";
        case "ts":
          return "ts";
        default:
          return this.materialFamilyID;
      }
    },

    tabContentHeight() {
      return this.editingData ? 'calc(100% - 75px)' : 'calc(100% - 60px)'
    },

    tabs() {
      return [
        {
          id: 'details',
          label: this.$i18n.tc("Detail", 2),
        },
        {
          id: 'accessories',
          label: this.$i18n.tc("Accessory", 2),
          disabled: this.materialFamilyID === "ac" || this.materialFamilyID === "ot",
        },
        {
          id: 'others',
          label: this.$i18n.tc("Other", 2),
          disabled: this.materialFamilyID === "ac" || this.materialFamilyID === "ot",
        },
        {
          id: 'custom_fields',
          label: this.$i18n.tc("CustomFields", 2),
          disabled: this.customFieldsInputs.length === 0,
        },
      ]
    },
  },

  watch: {
    activeTab(value) {
      if (this.tabs[value].id === "accessories" || this.tabs[value].id === "others") {
        this.loadSelectOptions();
      }
    },

    materialFamilyID() {
      this.activeTab = 0;
    }
  },

  methods: {
    ...mapActions(["fetchStockMaterialsList"]),

    async loadSelectOptions() {
      if (this.materialFamilyID) {
        try {
          let options = [];
          let allOptions = await this.fetchStockMaterialsList({
            material_family_id: this.tabs[this.activeTab].id === "accessories" ? "ac" : "ot",
            family_id_others_relation: this.relationFamilyIdSelect
          });

          for (let option of allOptions) {
            options.push({...option, code: option.sm_reference, name: option.sm_reference});
          }

          this.accessoriesAndOthersOptions = options;
        } catch (e) {
          console.error(e);
        }
      }
    },

    updateAccessories(event) {
      let accessory;
      if (event.field.varName === 'sm_reference'){
        accessory = this.accessoriesAndOthersOptions.find(option => option.sm_reference === event.value);
        let updatedAccessoryData = {
          id: event.data.id,
          editable: event.data.editable,
          sm_quantity: event.data.sm_quantity ? event.data.sm_quantity : null,
        }
        if (accessory) {
          updatedAccessoryData = {
            ...updatedAccessoryData,
            sm_id: accessory.sm_id,
            sm_reference: accessory.sm_reference,
            sm_description: accessory.sm_description,
          };
        }
        this.accessories[event.index] = updatedAccessoryData;
      } else {
        this.accessories[event.index][event.field.varName] = event.value
      }
      this.updateAccessoriesKey++
    },

    updateOthers(event) {
      let other;
      if (event.field.varName === "sm_reference") {
        other = this.accessoriesAndOthersOptions.find(option => option.sm_reference === event.value);
        let updatedOtherData = {
          id: event.data.id,
          editable: event.data.editable,
          sm_quantity: event.data.sm_quantity ? event.data.sm_quantity : null,
        }
        if (other) {
          updatedOtherData = {
            ...updatedOtherData,
            sm_id: other.sm_id,
            sm_reference: other.sm_reference,
            sm_description: other.sm_description,
          };
        }
        this.others[event.index] = updatedOtherData;
      } else {
        this.others[event.index][event.field.varName] = event.value
      }
    },

    onScrollBottom() {
    },

    onScrollTop() {
    },

    onSortClick(sortOrder, index) {
    },
  }
}

</script>

<style scoped>
.material-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: calc(70% - 8px);
}

.v-tabs >>> .v-tabs-bar {
  height: 39px;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}

.check-logo {
  height: 11px;
  min-width: 11px;;
}

.table-container {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/MaterialSpecificInfo.vue